exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "flight .flight-content .ui-widget-content {\n  border: none; }\n\nflight .flight-number {\n  font-weight: bold; }\n\nflight .start-hole {\n  text-align: center; }\n\nflight .start-time {\n  text-align: right; }\n\nflight .player-image img {\n  height: 30px;\n  width: auto; }\n\nflight .player-name {\n  white-space: normal; }\n  flight .player-name.withdrawn {\n    color: red; }\n  flight .player-name.clickable:hover {\n    text-decoration: underline;\n    font-weight: bold;\n    cursor: hand;\n    cursor: pointer; }\n\nflight .player-handicap {\n  text-align: right; }\n\nflight .player-buggy {\n  text-align: center; }\n\nflight .ui-panel-info {\n  background-color: #2e7d32;\n  color: white; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// D:/bs_work/toMigrate_litePortal/src/app/component-module/flight/flight.component.scss
// module id = ../../../../../src/app/component-module/flight/flight.component.scss
// module chunks = main